import type { FetchResponse } from 'openapi-fetch';
import type { paths } from '../api/coreApiSchema';
import { coreApiClient } from '../api/apiClient';

export const getApiVersions = async (): Promise<
  FetchResponse<paths['/core/v1/api-versions']['get'], { parseAs: 'json' }, 'application/json'>
> => {
  return await coreApiClient.GET('/core/v1/api-versions', {});
};
